import { useState } from 'react';
import { useDatos } from '../datos/DatosContext';
import { useAviso } from '../lib/avisos';
import { formatearFecha, isoHace, nuevoId } from '../lib/fechas';
import { Icono } from '../componentes/ui/Icono';
import { Cabecera, Demo, GrupoChips, TituloSeccion } from '../componentes/ui/basicos';

export function Bandeja() {
  const { datos, agregar, actualizar } = useDatos();
  const aviso = useAviso();
  const [texto, setTexto] = useState('');
  const [tipo, setTipo] = useState(datos.opciones.tiposBandeja[0] ?? 'Idea');

  const guardar = () => {
    const t = texto.trim();
    if (!t) { aviso('Escribe algo antes de guardar.'); return; }
    agregar('bandeja', { id: nuevoId('i'), texto: t, tipo, fecha: isoHace(0), estado: 'Pendiente' });
    setTexto('');
    aviso('Guardado en la bandeja (solo en esta sesión).');
  };

  return (
    <div className="stack-lg">
      <Cabecera antetitulo="Capturar" titulo="Bandeja de entrada" subtitulo="Guarda sin pensar dónde va. Ya lo ordenarás." />
      <div className="card stack">
        <div className="field">
          <label htmlFor="cap">¿Qué quieres guardar?</label>
          <textarea id="cap" rows={3} placeholder="Una idea, una frase, algo que soñaste…" value={texto} onChange={(e) => setTexto(e.target.value)} />
        </div>
        <GrupoChips etiqueta="Tipo" opciones={datos.opciones.tiposBandeja} seleccion={tipo} onElegir={setTipo} />
        <div className="between">
          <button className="btn" onClick={() => aviso('Solo visual: la grabación y transcripción de voz llegarán en una fase posterior.')}>
            <Icono nombre="mic" />Nota de voz <Demo>Fase posterior</Demo>
          </button>
          <button className="btn primary" onClick={guardar}>Guardar en la bandeja</button>
        </div>
      </div>

      <section className="stack-sm">
        <TituloSeccion>Lo que has capturado</TituloSeccion>
        {datos.bandeja.map((it) => (
          <div key={it.id} className="card" style={{ padding: '16px 18px' }}>
            <div className="between">
              <span className="row">
                <span className="tag">{it.tipo}</span>
                <span className={it.estado === 'Organizado' ? 'tag moss' : it.estado === 'Revisar' ? 'tag warn' : 'tag'}>{it.estado}</span>
              </span>
              <span className="muted small">{formatearFecha(it.fecha)}</span>
            </div>
            <p style={{ margin: '10px 0 12px' }}>{it.texto}</p>
            <div className="row">
              {it.estado !== 'Organizado' ? (
                <button className="btn" onClick={() => { actualizar('bandeja', it.id, { estado: 'Organizado' }); aviso('Marcado como organizado.'); }}>
                  <Icono nombre="check" tam="sm" />Marcar como organizado
                </button>
              ) : null}
              <button className="btn quiet" onClick={() => aviso('Solo visual: en la app podrás convertirlo en un sueño, una nota o un elemento de la biblioteca.')}>
                Mover a un módulo… <Demo />
              </button>
            </div>
          </div>
        ))}
      </section>
    </div>
  );
}
